import './BlockCard.css';

function BlockCard(props) {


  return (
    // <div id="BlockCard" style={blockstyle}>
    <div className="BlockCard">
      <img className="BlockCard-img" src={props.src} onClick={props.onClick} alt=''/>
      <div className='BlockCard-title'><b>{props.title}</b></div>
      <div className='BlockCard-caption'>{props.caption}</div>
    </div>

  );
}

export default BlockCard;
